<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">项目前期情况登记</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn"
        >返回项目详情</a
      >
    </div>
    <div class="form-content" v-if="project.name">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="140px" class="form">
          <update-info
            ref="create"
            :project="project"
            :userData="userData"
            :formByFather="form"
          ></update-info>

          <el-form-item label="">
            <div class="form-btn-room">
              <el-button
                :loading="formLoading"
                @click="startProject()"
                class="form-btn"
                type="success"
                >提交项目前期情况登记</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </el-col>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import Attachments from '@/components/Attachments'
import UpdateInfo from "@/page/form/updateInfo";

import ObjectUtil from "../mixins/objectUtil";
export default {
  mixins: [ObjectUtil],
  components: {
    UpdateInfo,
  },
  computed: {
    ...mapState({
      userData: (state) => state.main.userData,
    }),
  },
  data() {
    return {
      project: {},
      form: {
        projectId: "",
        kcdw: "",
        jldw: "",
        xqUptime: "",
        xqDowntime: "",
        kcUptime: "",
        kcDowntime: "",
        gsnsUptime: "",
        gsnsDowntime: "",
        bfgUptime: "",
        bfgDowntime: "",
        lxUptime: "", //立项计划
        lxDowntime: "",
        yskzjUptime: "",
        yskzjDowntime: "",
        fgysUptime: "",
        fgysDowntime: "",
        clcgxqUptime: "",
        clcgxqDowntime: "",
        clcgUptime: "",
        clcgDowntime: "",
        sgzbwcsj: "", //招标计划
        xmzbDowntime: "",
        jlzbUptime: "",
        jlzbDowntime: "",
        jhkgsj: "", //计划开工时间
        jhwgsj: "", //计划完工时间
        kgsj: "",
        wgsj: "",
        sgwcsj: "",
        ysjsUptime: "",

        earlyRemark: "", //备注
      },
      oldInfo: {},
      formLoading: false,
    };
  },
  mounted() {
    this.form.projectId = this.$route.params.projectId;
    this.getProject();
    this.getEarlyInfo();
  },
  methods: {
    // 获取项目已填写过的字段
    getEarlyInfo() {
      ajax.post(
        "/gc/project/early/info/detail",
        {
          projectId: this.form.projectId,
        },
        (res) => {
          this.oldInfo = res.vo;
          let _info = res.vo;
          for (var key in this.form) {
            if (_info[key]) {
              this.form[key] = _info[key];
            }
          }
        }
      );
    },
    // 获取项目
    getProject() {
      ajax.get("/gc/project/detail/" + this.form.projectId, "", (res) => {
        this.project = res.vo;

        // 修改当前选中的侧边栏
        this.setNavType(this.project);
      });
    },
    // 提交
    startProject() {
      this.form = this.$refs.create.getFromData();
      // if (this.form.underLine == "") {
      //   this.$message.error('请标注本次审批是否已线下通过')
      //   return
      // }

      // this.form.attachments = this.$refs.attachments.getAttachments()
      if (
        !this.form.lxUptime ||
        !this.form.sgzbwcsj ||
        !this.form.jhkgsj ||
        !this.form.jhwgsj
      ) {
        this.$message.error(
          '标红的项目即为预警项目，请认真填写，不可为空 (如"已完成/无"可选择项目创建时间)'
        );
        return;
      }

      this.formLoading = true;
      ajax.post(
        "/gc/project/early/info/save",
        this.form,
        (res) => {
          this.$message.success("提交项目前期情况登记成功");
          this.$router.back();
          this.formLoading = false;
        },
        (res) => {
          this.formLoading = false;
        }
      );
    },
  },
  watch: {},
};
</script>


// WEBPACK FOOTER //
// src/page/project/formLayout/updateInfo.vue